import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Row, Col, Table, Form, Button } from "react-bootstrap";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import moment from "moment";
import SearchIcon from "@material-ui/icons/Search";
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  InputBase,
  IconButton,
  Paper,
} from "@material-ui/core";

import SuperAdminTemplateBody from "./SuperAdminTemplateBody";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import propTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { admin_get_sms_templates_by_date } from "../../../../store/actions/SuperAdminActions/adminTemplatesAction";
import isEmpty from "../../../../store/validation/is-Empty";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";

const userTypeList = [
  { id: 0, title: "User" },
  { id: 1, title: "Vendor" },
];

const StatusList = [
  { id: 0, title: "Active" },
  { id: 1, title: "Inactive" },
];

function SuperAdminSMSTemplateManagement(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    search: "",
    anchorEl: null,
    restaurantReverse: "",
    user_type: "",
    statusAction: "",
    showFilter: false,
    userType: "",
    statusType: "",
  });

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const [dateQuery, setDateQuery] = useState("");
  useEffect(() => {
    dispatch(
      admin_get_sms_templates_by_date(
        auth.accessToken,
        dateQuery.startDate === undefined
          ? moment().format("YYYY-MM-DD")
          : dateQuery.startDate,
        dateQuery.endDate === undefined
          ? moment().format("YYYY-MM-DD")
          : dateQuery.endDate
      )
    );
  }, [dateQuery]);

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  /******************************
   * @DESC First Time Load Start
   ******************************/
  const [allSmsTemplates, setAllSmsTemplates] = useState([]);
  useEffect(() => {
    setAllSmsTemplates(props.smsTemplatesArr);
  }, [props.smsTemplatesArr]);

  /******************************
   * @DESC First Time Load End
   ******************************/
  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const handleClick = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
  };

  const handleClose = () => {
    setState({
      ...state,
      anchorEl: null,
    });
  };

  const handleSelect = (value) => () => {
    setState({
      ...state,
      restaurantReverse: value,
      anchorEl: false,
    });
  };

  const handleShowFilter = () => {
    setState({
      ...state,
      showFilter: !state.showFilter,
    });
  };

  const SetFormikDataState = (data) => {
    setState({
      ...state,
      showFilter: false,
      userType: data.values.userType,
      statusType:
        data.values.stausType === "Active"
          ? true
          : data.values.stausType === "Inactive"
          ? false
          : "",
    });
  };

  const formik = useFormik({
    initialValues: {
      userType: "",
      stausType: "",
    },

    onSubmit: (values) => {
      formik.userType = values.userType;
      formik.stausType = values.stausType;
      SetFormikDataState(formik);
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  const SuperAdminTemplateBodyFun = () => {
    const smsDataArr = allSmsTemplates;
    let filteredData = [];
    if (state.restaurantReverse === "A-Z") {
      filteredData = smsDataArr.sort((a, b) => {
        if (a.title < b.title) return -1;
        if (a.title > b.title) return 1;
        return 0;
      });
    } else if (state.restaurantReverse === "Z-A") {
      filteredData = smsDataArr.sort((a, b) => {
        if (a.title < b.title) return 1;
        if (a.title > b.title) return -1;
        return 0;
      });
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filteredData = smsDataArr.filter((getall) => {
        if (search.test(getall.message)) {
          return getall;
        } else if (search.test(getall.title)) {
          return getall;
        } else if (search.test(getall.sms_id)) {
          return getall;
        } else if (search.test("user")) {
          return getall.role === 0;
        } else {
          return false;
        }
      });
    } else if (state.userType) {
      filteredData = smsDataArr.filter(
        (notification) => notification.role === state.userType
      );
    } else if (state.statusType === true) {
      filteredData = smsDataArr.filter(
        (notification) => notification.status === state.statusType
      );
    } else if (state.statusType === false) {
      filteredData = smsDataArr.filter(
        (notification) => notification.status === state.statusType
      );
    } else {
      filteredData = smsDataArr;
    }
    if (!isEmpty(filteredData)) {
      return filteredData.map((data, index) => (
        <React.Fragment key={index}>
          <SuperAdminTemplateBody smsInfo={data} actionPerform="SMS" />
        </React.Fragment>
      ));
    }
  };

  const downloadData = {
    headers: [
      { label: " SMS ID", key: "id" },
      { label: "User Type", key: "user" },
      { label: " SMS Title", key: "title" },
      { label: " SMS Content", key: "content" },
      { label: "Frequency", key: "frequency" },
      { label: "Start Date - End Date", key: "date" },
      { label: " SMS Triggered Time", key: "time" },
    ],
    data: allSmsTemplates
      ? allSmsTemplates?.map((ele) => {
          return {
            id:
              ele?.sms_id !== undefined
                ? ele?.sms_id
                : ele?.email_id !== undefined
                ? ele?.email_id
                : ele?.notification_id !== undefined
                ? ele?.notification_id
                : "-",
            user: ele?.role === 0 ? "User" : ele?.role === 1 ? "Vendor" : "-",
            title: ele?.title,
            title: ele?.message,
            frequency:
              ele?.frequency === 0
                ? "Hourly"
                : ele?.frequency === 1
                ? "Daily"
                : ele?.frequency === 2
                ? "Weekly"
                : ele?.frequency === 3
                ? "Monthly"
                : ele?.frequency === 4
                ? "Yearly"
                : "-",
            date: `${moment(ele?.startDate).format("ll")}-${moment(
              ele?.endDate
            ).format("ll")}`,
            time: moment(ele?.startTriggeredAt).format("hh:mm A"),
          };
        })
      : [],
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-12 px-4">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue ">
                  SMS Template Management
                </div>
                <button
                  className="btn btn-danger btn2 btn-lg"
                  onClick={(e) =>
                    history.push({
                      pathname: "/superadminaddtemplate",
                      state: { actionPerform: "SMS" },
                    })
                  }
                >
                  + Add New
                </button>
              </div>
            </div>
            <div className="col-12 px-4">
              <Row>
                <Col md={3}>
                  <div className="filter-button-search">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search by SMS title"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by SMS title",
                        }}
                        onChange={onSearchChange}
                        value={state.search}
                      />
                    </Paper>
                  </div>
                </Col>
                <Col md={3}></Col>
                <Col md={6}>
                  <div className="row justify-content-end align-items-center">
                    <div className="col-5">
                      <div className="mr-3">
                        <SelectFilter
                          onDateChange={(data, type) =>
                            onDateChangeHandler(data, type)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <SortComponent
                          handleClick={handleClick}
                          anchorEl={state.anchorEl}
                          handleClose={handleClose}
                          selectClick={(data) => handleSelect(data)}
                        />
                        <div
                          className="f10-400"
                          align="center"
                          onClick={() => handleShowFilter()}
                        >
                          <img
                            src={require("../../../../assets/images/iconButton/filtericon.png")}
                            width="35px"
                          />
                          <br />
                          Filter
                        </div>
                        <div className="f10-400" align="center">
                          <CSVDownloader
                            filename={"SMS-Template-Management-Reports"}
                            headers={downloadData.headers}
                            data={downloadData.data}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              {state.showFilter && (
                <div className="row">
                  <div className="col-12">
                    <div className="enWhiteBox mt-3">
                      <Form className="row justify-content-between">
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Restaurant-type">
                                User Type
                              </InputLabel>
                              <Select
                                value={formik.values.userType}
                                onChange={formik.handleChange}
                                label="User Type"
                                onBlur={formik.handleBlur}
                                inputProps={{
                                  name: "userType",
                                  id: "userType",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {userTypeList.map((data, index) => {
                                  return (
                                    <MenuItem value={data.id} key={index}>
                                      {data.title}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group>
                            <FormControl variant="outlined" className="w-100">
                              <InputLabel htmlFor="outlined-Restaurant-type">
                                Status
                              </InputLabel>
                              <Select
                                value={formik.values.stausType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                label="Status"
                                inputProps={{
                                  name: "stausType",
                                  id: "stausType",
                                }}
                                IconComponent={KeyboardArrowDownIcon}
                              >
                                {StatusList.map((data, index) => {
                                  return (
                                    <MenuItem value={data.title} key={index}>
                                      {data.title}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </Col>

                        <Col md={12}>
                          <div className="d-flex align-items-center">
                            <Button
                              variant="outline-secondary"
                              className="btn-lg mr-4 px-5"
                              onClick={() => handleShowFilter()}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="danger"
                              className="btn-lg px-5"
                              onClick={(e) => onClickSave(e)}
                            >
                              Search
                            </Button>
                          </div>
                        </Col>
                      </Form>
                    </div>
                  </div>
                </div>
              )}
              <div className="user-table-reusable-superadmin table-responsive">
                <Table>
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "8%" }} className="f12-500">
                        SMS <br /> ID
                      </th>
                      <th style={{ width: "10%" }} className="f12-500">
                        User <br />
                        Type
                      </th>
                      <th style={{ width: "10%" }} className="f12-500">
                        SMS Title
                      </th>
                      <th style={{ width: "18%" }} className="f12-500">
                        SMS Content
                      </th>
                      <th style={{ width: "6%" }} className="f12-500">
                        Status
                      </th>
                      <th style={{ width: "8%" }} className="f12-500">
                        Frequency
                      </th>
                      <th style={{ width: "9%" }} className="f12-500">
                        Start Date
                      </th>
                      <th style={{ width: "9%" }} className="f12-500">
                        End Date
                      </th>
                      <th style={{ width: "10%" }} className="f12-500">
                        SMS triggered <br /> time
                      </th>
                      <th style={{ width: "12%" }} className="f12-500">
                        Action
                      </th>
                    </tr>
                  </thead>
                  {SuperAdminTemplateBodyFun()}
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

SuperAdminSMSTemplateManagement.propTypes = {
  auth: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
  admin_get_sms_templates_by_date: propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  smsTemplatesArr: state.superAdminTemplates.getSmsTemplates,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_get_sms_templates_by_date,
})(withRouter(SuperAdminSMSTemplateManagement));
